
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/guild'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HeaderGroup from '../HeaderGroup/index.vue'
import CityAvatar from '../CityAvatar/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    HeaderGroup,
    CityAvatar
  }
})
export default class RecommdCard extends Vue {
  @Prop({ required: true, type: Object }) readonly dataSource!: CityTypeInfo & { subTitle: string }

  get EnumCityStatus() {
    return EnumCityStatus
  }
  get btnText() {
    return this.dataSource.recruitStatus === true ? '负责人招募' : '助力'
  }
  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  @Emit('to-city-page')
  handleClick() {
    return this.dataSource.id
  }

  handleOperation() {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }

    if (this.dataSource.recruitStatus === true) {
      this.$emit('show-recruit', this.dataSource)
    } else if (this.dataSource.status === EnumCityStatus.Assistance) {
      this.$emit('show-assistance', this.dataSource)
    }
  }

  handleJoin() {
    if (!this.UserInfo.id) {
      this.$emit('unauthorized')
      return
    }
    this.$emit('show-join', this.dataSource)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
